// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"bb7c934f","453":"71ce5824","977":"810ac6d1"}[chunkId] + ".chunk.js";
};